import {
  collectionGroup,
  collection,
  getDocs,
  where,
  query,
  orderBy,
  limit,
  getDoc,
  doc,
  getCountFromServer,
} from "firebase/firestore";
import { db } from "../firebase";
import { Company } from "../model/Companies";
import { Passcode } from "../model/Users";
import { User } from "../model/Users";

const userQuery = {
  // 利用者リスト取得
  getUserList: async (company: Company) => {
    console.log("user getUserList access");
    const usersRef = await getDocs(
      query(
        collection(db, `companies/${company.id}/users`),
        where('deleteAt', '==', null)
      )
    );
    return usersRef.docs.map((doc) => doc.data());
  },
  // 所属グループ取得
  getGroups: async (userId: string) => {
    console.log("user getGroups access");
    const attendingGroupsRef = await getDocs(
      query(collectionGroup(db, "attendingGroups"),
        where('userId', '==', userId)));
    return attendingGroupsRef.docs.map((group) => group.data());
  },
  // パスコード取得
  getPasscode: async (tenantId: string, userId: string): Promise<Passcode[] | any> => {
    console.log("user getPasscode access");
    try {
      const passcodeRef = await getDocs(
        query(collection(db, `companies/${tenantId}/users/${userId}/passcode`),
          orderBy('createAt', 'asc'),
          limit(1)));
      return passcodeRef.docs.map((doc) => doc.data() as Passcode);
    } catch (err: any) {
      console.error(err);
      return err;
    }
  },
  getUserData: async (tenantId: string, userId: string): Promise<User> => {
    console.log("user getUserData access");
    const userRef = await getDoc(
      doc(db, `/companies/${tenantId}/users`, userId)
    );
    const user = userRef.data();
    return user as User;
  },
  // 各登録数取得
  getCompanyUserCounts: async (companyId: string) => {
    const baseRef = collection(db, "companies", companyId, "users");
    
    // ID登録数
    const idRegisteredSnap = await getCountFromServer(
      query(baseRef, where("lastName", "!=", null), where("accountSuspensionFlg", "==", false))
    );

    // アプリ利用可能数
    const usableSnap = await getCountFromServer(
      query(baseRef, where("deleteFlg", "==", false), where("accountSuspensionFlg", "==", false))
    );

    // アプリ利用不可数
    const unusableSnap = await getCountFromServer(
      query(baseRef, where("deleteFlg", "==", true))
    );

    // アプリ利用停止数
    const suspendedSnap = await getCountFromServer(
      query(baseRef, where("accountSuspensionFlg", "==", true))
    );

    return {
      idRegistered: idRegisteredSnap.data().count,
      usable: usableSnap.data().count,
      unusable: unusableSnap.data().count,
      suspended: suspendedSnap.data().count,
    };
  }
}

export default userQuery;